import { useMutation, gql } from '@apollo/client';
import {
  EditarHorarioMutation,
  EditarHorarioMutationVariables,
} from './__generated__/EditarHorarioMutation';

const EDITAR_HORARIO_MUTATION = gql`
  mutation EditarHorarioMutation($id_horario: Int!, $hora_inicio: String, $hora_fim: String) {
    editarHorario(
      input: { id_horario: $id_horario, hora_inicio: $hora_inicio, hora_fim: $hora_fim }
    ) {
      id_horario
      hora_inicio
      hora_fim
    }
  }
`;

const useEditarHorarioMutation = () => {
  return useMutation<EditarHorarioMutation, EditarHorarioMutationVariables>(
    EDITAR_HORARIO_MUTATION
  );
};

export { useEditarHorarioMutation };
